<template lang="pug">
.vendor-view-brief(v-loading="loading")
  title-bar {{ $t('订单信息') }}
  div(style="margin-left: 20px")
    el-row
      el-col(:span="4") {{ $t('项目名称') }}
      el-col(:span="15") {{ orderInfo.campaign_name }}
    el-row
      el-col(:span="4") {{ $t('订单名称') }}
      el-col(:span="15") {{ orderInfo.sub_final_scope_name }}
    category(:data="orderInfo.category_scope")
</template>

<script>
import TitleBar from '@/components/TitleBar'
import axios from 'axios'
import FooterButton from '@/components/FooterButton'
import Category from '@/components/Category'

export default {
  components: {
    TitleBar,
    FooterButton,
    Category
  },
  data () {
    return {
      orderInfo: {},
      loading: true
    }
  },
  mounted () {
    this.getOrderInfo()
  },
  computed: {
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    }
  },
  methods: {
    async getOrderInfo () {
      try {
        this.orderInfo = await axios.get('/management/subfinal/getContractInfo', {
          params: {
            sub_final_scope_id: this.subFinalScopeId
          }
        })
      } catch (err) {
        throw new Error(err)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
